import axios from "@axios";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    items: [],
    idItems: [],
    assignedIdItems: [],
    types: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((camera) => ({
        value: camera.id,
        label: camera.camera.name,
      }));
    },
    getJustIdsItems(state) {
      return state.idItems;
    },
    getAssignedIdsItems(state) {
      return state.assignedIdItems;
    },
    getTypesItems(state) {
      return state.types.map((deviceType) => ({
        value: deviceType,
        label: deviceType,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    setJustIdsData(state, value) {
      state.idItems = value;
    },
    setAssignedIdItems(state, value) {
      state.assignedIdItems = value;
    },
    setTypesItems(state, value) {
      state.types = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get("v1/proxy_camera", {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });

      let { data } = response;

      if (!response.data) {
        return [];
      }

      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();

        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "camera-proxy",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Cameras report",
          body: "Downloaded successfully",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else if (params.action == "justIds" && !params.assign) {
        commit("setJustIdsData", data.data);
      } else if (params.action == "justIds" && params.assign) {
        commit("setAssignedIdItems", data.data);
      } else {
        commit("setData", data.data);
      }
      return data;
    },
    async updateStatus(_, id) {
      const { data } = await axios.put(`v1/device/status/${id}`);

      return data;
    },
    async getDeviceTypes({ commit }, params) {
      const { data } = await axios.get("v1/proxy_camera/getDeviceTypes", { params });

      if (!data) {
        return [];
      }

      commit("setTypesItems", data.data);
      return data;
    },
    clear({ commit }) {
      commit("setData", []);
    },
    clearAll({ commit }) {
      commit("setData", []);
      commit("setJustIdsData", []);
      commit("setAssignedIdItems", []);
      commit("setTypesItems", []);
    },
  },
};
